<template>
  <b-container>
    <LoadingIndicator 
      v-if="isLoading"
    />
    <div v-if="!isLoading">
      <b-row>
        <b-col></b-col>
        <b-col cols="auto" style="width: 400px">
          <h2>Reset Password</h2>
          <b-row>
            <b-col>
              <b-form v-if="showForm" @submit.prevent="resetPasswordSubmit">
                <b-form-group
                  label="New Password"
                  label-for="create-password"
                  :invalid-feedback="newPasswordFeedback"
                  :state="errors.length == 0 ? null : errors.length == 0 ? null : newPasswordState"
                  description="Password must be at least 6 characters long, have at least 1 lowercase letter, at least 1 uppercase letter, at least 1 number, and at least 1 non-alphanumeric character">
                  <b-form-input id="create-password" type="password" :state="errors.length == 0 ? null : newPasswordState"
                    v-model="resetPasswordForm.password"
                    required />
                </b-form-group>
                <b-form-group
                  label="Confirm Password"
                  label-for="confirm-password"
                  :invalid-feedback="confirmPasswordFeedback"
                  :state="errors.length == 0 ? null : confirmPasswordState"
                  description="Re-enter password">
                  <b-form-input id="confirm-password" type="password" :state="errors.length == 0 ? null : confirmPasswordState"
                    v-model="resetPasswordForm.confirmPassword"
                    required />
                </b-form-group>
                <b-button type="submit" variant="primary" class="float-right ml-2"
                  :disabled="isSending">
                  <div v-if="!isSending">Submit</div>
                  <b-spinner small v-if="isSending" label="Spinning"></b-spinner>
                </b-button>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseMessageBlock :messages="errors"></BaseMessageBlock>
              <BaseMessageBlock :type="'Success'" :messages="messages"></BaseMessageBlock>
            </b-col>
          </b-row>
          <b-link v-if="showBackToLogin" to="/login">Back to login </b-link>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";

export default {
  name: "ResetPassword",
  data() {
    return {
      errors: [],
      messages: [],
      isSending: false,
      isLoading: false,
      showForm: false,
      showBackToLogin: false,
      resetPasswordForm: {
        password: '',
        confirmPassword: ''
      },
      userId: '',
      code: ''
    }
  },
  mounted() {
    this.isLoading = true;
    let id = this.$route.query.uid;
    let code = this.$route.query.code;
    if (!id) {
      this.errors.push({ message: "Missing User Id" });
      this.isLoading = false;
    } else if (!code) {
      this.errors.push({ message: "Missing Reset Password Code" });
    } else {
      this.userId = id;
      this.code = code;
      this.showForm = true;
    }
    this.isLoading = false;
  },
  methods: {
    resetPasswordSubmit() {
      if (this.newPasswordState && this.confirmPasswordState) {
        this.errors = [];
        this.isSending = true;

        let request = {
          userId: this.userId,
          code: this.code,
          password: this.resetPasswordForm.password
        };

        axios
          .post(`${this.$api_url}/identity/reset-password`, request, this.getReqConfig())
          .then(() => {
            this.messages.push({ message: 'Password successfully reset!'});
            this.showForm = false;
            this.showBackToLogin = true;
          })
          .catch(err => {
            this.errors.push(err);
          })
          .finally(() => {
            this.isSending = false;
          });
      }
    }
  },
  computed: {
    newPasswordState() {
      if (this.newPasswordFeedback == null) return null;
      return this.newPasswordFeedback.length === 0;
    },
    newPasswordFeedback() {
      let input = this.resetPasswordForm.password.trim();
      let issues = []
      if (input.length === 0) {
        return null;
      }
      if (input.length < 6)
        issues.push("less than 6 characters long");
      if (input.toLowerCase() === input)
        issues.push("missing an upper case letter");
      if (input.toUpperCase() === input)
        issues.push("missing a lower case letter");
      if (!/.*[0-9].*/.test(input)) {
        issues.push("missing a number");
      }
      return issues.length > 0 ? `Password is: ${issues.join(", ")}` : '';
    },
    confirmPasswordState() {
      if (this.confirmPasswordFeedback == null) return null;
      return this.confirmPasswordFeedback.length === 0;
    },
    confirmPasswordFeedback(){
      let input = this.resetPasswordForm.confirmPassword.trim();
      if (input.length === 0){
        return null;
      }
      if (input !== this.resetPasswordForm.password) {
        return "Password must match"
      } else {
        return "";
      }
    }
  }
}
</script>